import { createFileRoute, redirect } from '@tanstack/react-router';
import { z } from 'zod';

/**
 * Alias de l'écran d'activation de compte.
 *
 * L'e-mail d'invitation envoyé par l'API (`MailService.sendInvitation`) pointe
 * vers `/invitation?token=…` alors que l'écran vit sous `/invite/$token`
 * (défaut DEF-001 de la recette MVP). Cette route redirige vers l'écran réel
 * pour que le lien reçu par un nouvel utilisateur fonctionne.
 */
export const Route = createFileRoute('/invitation')({
  validateSearch: z.object({ token: z.string().optional() }),
  beforeLoad: ({ search }) => {
    if (search.token) {
      // eslint-disable-next-line @typescript-eslint/only-throw-error -- TanStack Router utilise une exception de redirection
      throw redirect({ to: '/invite/$token', params: { token: search.token }, replace: true });
    }
    // eslint-disable-next-line @typescript-eslint/only-throw-error -- idem
    throw redirect({ to: '/login', replace: true });
  },
});
